import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentoLight } from "../../common/models/documento/documento-light";
import { FrontEndMapping } from '../configuration/front-end-mapping';
import { ServicePathsSettings } from '../configuration/service-paths-settings';
import { UrlSettingsCore } from '../configuration/url-settings-core';
import { FascicoloPraticaUtil } from './fascicolo-pratica-util';

@Injectable()
export class RoutingConfigurationUtilService extends FascicoloPraticaUtil {

  constructor(private router: Router, private frontEndMapping: FrontEndMapping) {
    super();
  }

  getRoutingVisualizzazionePraticaModule(tipoPratica: any): string {
    let pathPratica = '';
    this.frontEndMapping.getListTipiPratica(tipoPratica).subscribe(res => {
      pathPratica = res;
    });
    return 'pratica/' + pathPratica + '/' + ServicePathsSettings.VIEW_LABEL; // mapFe.tipiPratica[tipoPratica] + '/' + ServicePathsSettings.VIEW_LABEL;
  }

  /*getRoutingCreazionePraticaModule(tipoPratica: any): string {
    return 'creazione/pratica/' + mapFe.tipiPratica[tipoPratica];
  }*/

  getRoutingVisualizzazioneFascicoloModule(tipoPratica: any, tipoFascicolo: any): string {
    let pathPratica = '';
    this.frontEndMapping.getListTipiPratica(tipoPratica).subscribe(res => {
      pathPratica = res;
    });
    let pathFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(tipoFascicolo).subscribe(res => {
      pathFascicolo = res;
    });
    return 'fascicolo/' + pathPratica + '/' + pathFascicolo; // mapFe.tipiPratica[tipoPratica] + '/' + mapFe.tipiFascicolo[tipoFascicolo];
  }

  /*getRoutingCreazioneFascicoloModule(tipoPratica: any, tipoFascicolo: any): string {
    return 'creazione/fascicolo/' + mapFe.tipiPratica[tipoPratica] + '/' + mapFe.tipiFascicolo[tipoFascicolo];
  }*/

  getRoutingInserimentoFascicoloModule(tipoPratica: any, tipoFascicolo: any): string {
    let pathPratica = '';
    this.frontEndMapping.getListTipiPratica(tipoPratica).subscribe(res => {
      pathPratica = res;
    });
    let pathFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(tipoFascicolo).subscribe(res => {
      pathFascicolo = res;
    });
    return 'inserimento/fascicolo/' + pathPratica + '/' + pathFascicolo + '/' + ServicePathsSettings.insLabel; // mapFe.tipiPratica[tipoPratica] + '/' + mapFe.tipiFascicolo[tipoFascicolo] + '/' + ServicePathsSettings.insLabel;
  }

  checkStatoFascicolo(fascicolo, tipoPratica: any, tipoFascicolo: any, nomePagina: string, comuneAiModuli: boolean = false, pratica = null, isWizard: boolean = false) {
    if (!isWizard) {
      if (pratica === null && fascicolo) {
        if (this.isFascicoloToComplete(fascicolo) || this.isFascicoloBozza(fascicolo)) {
          if (comuneAiModuli) {
            this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina + '_fascicolo', fascicolo.id]);
          } else {
            this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo), fascicolo.id]);
          }
        }
        if (this.isFascicoloInSmistamento(fascicolo)) {
          this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO, fascicolo.id]);
        }
        if (this.isFascicoloInAssegnazione(fascicolo)) {
          this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA, fascicolo.id]);
        }
        if (this.isFascicoloInAssegnazioneLegale(fascicolo)) {
          this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_LEGALI_FASCICOLO, fascicolo.id]);
        }
        if (this.isFascicoloInLavorazione(fascicolo)) {
          this.router.navigate([this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, fascicolo.id]);
        }
      }
      if (pratica != null) {
        if (fascicolo) {
          this.checkStatoPratica(pratica, tipoPratica, tipoFascicolo, nomePagina, fascicolo.id);
        }
        if (!fascicolo) {
          this.checkStatoPratica(pratica, tipoPratica, tipoFascicolo, nomePagina, null);
        }

      }
    } else {
      if (isWizard && fascicolo) {
        this.checkStatoFascicoloInInserimento(fascicolo, tipoPratica, tipoFascicolo, nomePagina, comuneAiModuli, pratica);
      }
    }
  }

  checkStatoFascicoloDoc(fascicolo, tipoPratica: any, tipoFascicolo: any, nomePagina: string, comuneAiModuli: boolean = false, pratica = null, isWizard: boolean = false, documento: DocumentoLight) {
    let fullUrl = null;
    let urlTree = null;
    let urlSerialized = null;  
    if (pratica === null && fascicolo) {
        if (this.isFascicoloToComplete(fascicolo) || this.isFascicoloBozza(fascicolo)) {
          if (comuneAiModuli) {
             urlTree = this.router.createUrlTree([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina + '_fascicolo', fascicolo.id]);
          }
        }
        if (this.isFascicoloInSmistamento(fascicolo)) {
          urlTree = this.router.createUrlTree([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO, fascicolo.id]);
        }
        if (this.isFascicoloInAssegnazione(fascicolo)) {
          urlTree = this.router.createUrlTree([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA, fascicolo.id]);
        }
        if (this.isFascicoloInAssegnazioneLegale(fascicolo)) {
          urlTree = this.router.createUrlTree([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_LEGALI_FASCICOLO, fascicolo.id]);
        }
        if(this.isFascicoloDefinito(fascicolo)){
          urlTree = this.router.createUrlTree([this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, fascicolo.id]);
        }
        if (this.isFascicoloInLavorazione(fascicolo)) {
          if (documento && documento.intestazione?.campi?.idDocumento) {
            // Passo i queryParams solo se esistono
            urlTree = this.router.createUrlTree(
              [this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, fascicolo.id],
              { queryParams: { idDoc: documento.intestazione.campi.idDocumento } }
            );
          } else {
          // Altrimenti solo il percorso senza queryParams
            urlTree = this.router.createUrlTree(
              [this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, fascicolo.id]
            );
          }
        }
      }
      if(!urlTree) return;
      urlSerialized = this.router.serializeUrl(urlTree);
      fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}`;
      window.open(fullUrl, '_blank');
  }

  checkStatoFascicoloInInserimento(fascicolo, tipoPratica: any, tipoFascicolo: any, nomePagina: string, comuneAiModuli: boolean = false, pratica = null) {
    if (pratica === null && fascicolo) {
      if (!this.isFascicoloInLavorazione(fascicolo)) {
        if (nomePagina !== UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA && nomePagina !== UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO) {
          this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina + '_fascicolo', fascicolo.id]);
        } else {
          if (nomePagina === UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA) {
            this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA, fascicolo.id]);
          }
          if (nomePagina === UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO) {
            this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO, fascicolo.id]);
          }
        }
      } else {
        if (comuneAiModuli) {
          this.router.navigate([this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, fascicolo.id]);
        }
        if (!comuneAiModuli) {
          this.router.navigate([this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo), fascicolo.id]);
        }
      }
    }
    if (pratica != null && fascicolo) {
      this.checkStatoPratica(pratica, tipoPratica, tipoFascicolo, nomePagina);
    }
    if (pratica != null && fascicolo === null) {
      this.checkStatoPratica(pratica, tipoPratica, null, nomePagina, null);
    }
  }

  checkStatoFascicoloAndGetRoutingPath(fascicolo, tipoPratica: any, tipoFascicolo: any): string {
    let path: string;
    if (this.isFascicoloToComplete(fascicolo) || this.isFascicoloBozza(fascicolo)) {
      path = this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo);
    }
    if (this.isFascicoloInSmistamento(fascicolo)) {
      path = this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_SMISTAMENTO;
    }
    if (this.isFascicoloInAssegnazione(fascicolo)) {
      path = this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_ASSEGNAZIONE_PER_COMPETENZA;
    }
    if (this.isFascicoloInAssegnazioneLegale(fascicolo)) {
      path = this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + UrlSettingsCore.URL_INSERIMENTO_LEGALI_FASCICOLO;
    }
    if (this.isFascicoloInLavorazione(fascicolo) || fascicolo?.definito || this.isFascicoloRiunito(fascicolo) || fascicolo?.sospeso || this.isFascicoloArchiviato(fascicolo)) {
      path = this.getRoutingVisualizzazioneFascicoloModule(tipoPratica, tipoFascicolo);
    }
    return path;
  }

  checkStatoPratica(pratica, tipoPratica: any, tipoFascicolo: any = null, nomePagina: string, idFascicolo: string = null) {
    if (pratica && tipoFascicolo === null) {
      this.router.navigate([this.getRoutingVisualizzazionePraticaModule(tipoPratica), pratica.id]);
    } else {
      if (this.isPraticaBozza(pratica) && idFascicolo !== null) {
        this.router.navigate([this.getRoutingInserimentoFascicoloModule(tipoPratica, tipoFascicolo) + '/' + nomePagina, idFascicolo]);
      }
    }
  }

  isFascicoloWritable(pratica): boolean {
    let enable: boolean;
    if (this.isPraticaArchiviata(pratica) || this.isPraticaRiunita(pratica)) {
      enable = false;
    } else {
      enable = true;
    }
    return enable;
  }

  isPraticaWritable(pratica): boolean {
    let enable: boolean;
    if (this.isPraticaArchiviata(pratica) || this.isPraticaRiunita(pratica)) {
      enable = false;
    } else {
      enable = true;
    }
    return enable;
  }
}
